import { ReactNode } from 'react';
import type { NatFileType, AvetmissResponse } from '@duke-hq/avetmiss/NATTypes';

import {
  NATCacheContext,
  type NATCacheContextType,
  type NATReportStatus,
  type NATReportTiming,
} from './NATCacheContext';

export interface NATCacheProviderProps {
  children: ReactNode;
  onCacheData: (natFileId: NatFileType, data: AvetmissResponse) => void;
  onUpdateRowData: (
    natFileId: NatFileType,
    rowIndex: number,
    updatedData: Record<string, string>,
  ) => void;
  onGetCachedData: (
    natFileId: NatFileType,
    fromDate: string,
    toDate: string,
  ) => AvetmissResponse | null;
  onTriggerGeneration?: (natFileId: NatFileType, options?: { force?: boolean }) => Promise<void>;
  onGetStatus?: (natFileId: NatFileType) => NATReportStatus;
  onGetTiming?: (natFileId: NatFileType) => NATReportTiming | null;
}

export function NATCacheProvider({
  children,
  onCacheData,
  onUpdateRowData,
  onGetCachedData,
  onTriggerGeneration = async () => {},
  onGetStatus = () => 'idle' as const,
  onGetTiming = () => null,
}: NATCacheProviderProps) {
  const contextValue: NATCacheContextType = {
    cacheData: onCacheData,
    updateRowData: onUpdateRowData,
    getCachedData: onGetCachedData,
    triggerGeneration: onTriggerGeneration,
    getStatus: onGetStatus,
    getTiming: onGetTiming,
  };

  return <NATCacheContext.Provider value={contextValue}>{children}</NATCacheContext.Provider>;
}
